import BaseCrudRepository from '@/repositories/BaseCrudRepository';
import HttpClient from '@/util/http/HttpClient';
import Label from '@/repositories/data/content/label/Label';

export default class LabelRepository extends BaseCrudRepository<number, Label, Label> {
    constructor(client: HttpClient) {
        super(client, 'rest/admin/label/');
    }
}
